module.exports = __webpack_public_path__ + "img/login-logo.5470911a.png";